/* Personalisation service fee: keeps one "personalisation-service" unit in the cart per personalised item.
   Runs on the cart page, when the minicart opens, and just before checkout. No-op if the service product is missing. */
(function () {
  var HANDLE = 'personalisation-service';
  var running = null;
  var variantId = null;

  function json(url, opts) {
    return fetch(url, opts).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function post(url, body) {
    return json(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function getVariant() {
    if (variantId) return Promise.resolve(variantId);
    return json('/products/' + HANDLE + '.js').then(function (p) {
      var v = p.variants.filter(function (x) { return x.available; })[0];
      variantId = v ? v.id : null;
      return variantId;
    }).catch(function () { return null; });
  }

  function sync() {
    if (running) return running;
    running = json('/cart.js').then(function (cart) {
      var want = 0, line = null;
      cart.items.forEach(function (it) {
        if (it.handle === HANDLE) { line = it; return; }
        var p = it.properties && it.properties.Personalisation;
        if (p && String(p).trim()) want += it.quantity;
      });
      var have = line ? line.quantity : 0;
      if (want === have) return false;
      if (line) return post('/cart/change.js', { id: line.key, quantity: want }).then(function () { return true; });
      return getVariant().then(function (id) {
        return id ? post('/cart/add.js', { items: [{ id: id, quantity: want }] }).then(function () { return true; }) : false;
      });
    }).catch(function () { return false; }).then(function (changed) { running = null; return changed; });
    return running;
  }

  // Cart page: fix on load, reload once if the cart changed.
  if (/^\/cart\/?$/.test(location.pathname)) {
    sync().then(function (changed) { if (changed) location.reload(); });
  }

  // Minicart: sync when it opens or after any cart mutation, then refresh the drawer totals.
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) && !running) {
      p.then(function () {
        return sync();
      }).then(function (changed) {
        if (!changed) return;
        if (/^\/cart\/?$/.test(location.pathname)) return location.reload();
        document.dispatchEvent(new CustomEvent('infinote:cart-fee-updated'));
      });
    }
    return p;
  };

  // Before checkout: make sure the fee is in the cart, then let the submit continue.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn || btn.dataset.feeChecked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    sync().then(function () {
      btn.dataset.feeChecked = '1';
      btn.click();
    });
  }, true);
})();
